<div class="control-list-container">
  <!-- 無權限提示 -->
  <div class="alert alert-warning mb-3" *ngIf="!componentPermission && !permissionLoading">
    <i class="fas fa-exclamation-triangle"></i>
    {{ 'control_list.permission.no_access' | translate }}
  </div>

  <div class="header-section">
    <h1>{{ 'control_list.title' | translate }}</h1>
    <div class="actions">
      <!-- 新增按鈕：需要 create 權限 -->
      <button
        *ngIf="hasPermission('create')"
        class="add-button"
        (click)="openAddForm()">
        <i class="fas fa-plus"></i> {{ 'control_list.add_item' | translate }}
      </button>
    </div>
  </div>

  <div class="filters-section">
    <!-- 檢視模式切換 -->
    <div class="view-mode-toggle">
      <button 
        class="view-mode-btn" 
        [class.active]="viewMode === 'list'"
        (click)="switchViewMode('list')">
        <i class="fas fa-list"></i> {{ 'control_list.view_mode.list' | translate }}
      </button>
      <button 
        class="view-mode-btn" 
        [class.active]="viewMode === 'calendar'"
        data-view="calendar"
        (click)="switchViewMode('calendar')">
        <i class="fas fa-calendar"></i> {{ 'control_list.view_mode.calendar' | translate }}
      </button>
    </div>

    <div class="filter-group">
      <label for="filterStatus">{{ 'control_list.filter.status_label' | translate }}</label>
      <select id="filterStatus" [(ngModel)]="filterStatus">
        <option value="all">{{ 'control_list.filter.status.all' | translate }}</option>
        <option value="pending">{{ 'control_list.filter.status.pending' | translate }}</option>
        <option value="inProgress">{{ 'control_list.filter.status.in_progress' | translate }}</option>
        <option value="completed">{{ 'control_list.filter.status.completed' | translate }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="filterDepartment">{{ 'control_list.filter.department_label' | translate }}</label>
      <select id="filterDepartment" [(ngModel)]="filterDepartmentId">
        <option value="all">{{ 'control_list.filter.department.all' | translate }}</option>
        <option *ngFor="let dept of departments" [value]="dept.id">{{ formatDepartmentName(dept) }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="sortBy">{{ 'control_list.filter.sort_label' | translate }}</label>
      <select id="sortBy" [(ngModel)]="sortBy">
        <option value="updatedDate">{{ 'control_list.filter.sort.updated_date' | translate }}</option>
        <option value="dueDate">{{ 'control_list.filter.sort.due_date' | translate }}</option>
        <option value="priority">{{ 'control_list.filter.sort.priority' | translate }}</option>
      </select>
    </div>
  </div>

  <!-- 控制項目內容 -->
  <div class="content-container">
    
    <!-- 列表檢視 -->
    <div *ngIf="viewMode === 'list'" class="items-container">
      <div *ngIf="getFilteredItems().length === 0" class="no-items">
        {{ 'control_list.no_items' | translate }}
      </div>

      <div class="item-card" *ngFor="let item of getFilteredItems()">
      <!-- 直接顯示模式 -->
      <div class="item-display">
        <div class="item-header">
          <h3 class="item-title">{{ item.title }}</h3>
          <div class="item-badges">
            <span class="priority-badge" [ngClass]="getPriorityClass(item.priority)">
              {{ getPriorityText(item.priority) }}
            </span>
            <span class="status-badge" [ngClass]="getStatusClass(item.status)">
              {{ getStatusText(item.status) }}
            </span>
          </div>
        </div>

        <div class="item-description">
          {{ item.description || ('control_list.no_description' | translate) }}
        </div>

        <div class="item-details">
          <div class="detail">
            <i class="fas fa-calendar-alt"></i>
            {{ 'control_list.due_date' | translate }}: {{ item.dueDate }}
          </div>
          <div class="detail" *ngIf="item.departmentName">
            <i class="fas fa-building"></i>
            {{ 'control_list.department' | translate }}: {{ item.departmentName }}
          </div>
          <div class="detail" *ngIf="item.assignedTo">
            <i class="fas fa-user"></i>
            {{ 'control_list.assigned_to' | translate }}: {{ item.assignedTo }}
          </div>
          <div class="detail" *ngIf="item.completedDate">
            <i class="fas fa-check-circle"></i>
            {{ 'control_list.completed_date' | translate }}: {{ item.completedDate }}
          </div>
        </div>

        <div class="item-actions">
          <!-- 狀態變更：需要 edit 權限 -->
          <div class="status-actions" *ngIf="hasPermission('edit')">
            <button [disabled]="item.status === 'pending'"
                    [ngClass]="{'active': item.status === 'pending'}"
                    (click)="changeStatus(item, 'pending')">{{ 'control_list.status.pending' | translate }}</button>
            <button [disabled]="item.status === 'inProgress'"
                    [ngClass]="{'active': item.status === 'inProgress'}"
                    (click)="changeStatus(item, 'inProgress')">{{ 'control_list.status.in_progress' | translate }}</button>
            <button [disabled]="item.status === 'completed'"
                    [ngClass]="{'active': item.status === 'completed'}"
                    (click)="changeStatus(item, 'completed')">{{ 'control_list.status.completed' | translate }}</button>
          </div>
          <div class="edit-actions">
            <!-- 編輯按鈕：需要 edit 權限 -->
            <button
              *ngIf="hasPermission('edit')"
              class="edit-button"
              (click)="editItem(item)">
              <i class="fas fa-edit"></i>
            </button>
            <!-- 刪除按鈕：需要 delete 權限 -->
            <button
              *ngIf="hasPermission('delete')"
              class="delete-button"
              (click)="deleteItem(item.id)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- 行事曆檢視 -->
    <div *ngIf="viewMode === 'calendar'" class="calendar-container">
      
      <!-- 月份導航 -->
      <div class="calendar-header">
        <button class="nav-button" (click)="previousMonth()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <h2 class="month-title">{{ getMonthYearText() }}</h2>
        <button class="nav-button" (click)="nextMonth()">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>

      <!-- 星期標題 -->
      <div class="calendar-weekdays">
        <div class="weekday" *ngFor="let day of getWeekDaysTranslated()">{{ day }}</div>
      </div>

      <!-- 日期格子 -->
      <div class="calendar-grid">
        <div 
          class="calendar-day" 
          *ngFor="let calendarDay of calendarDays"
          [class.other-month]="!calendarDay.isCurrentMonth"
          [class.today]="isToday(calendarDay.date)"
          [class.has-items]="calendarDay.items.length > 0">
          
          <!-- 日期數字 -->
          <div class="day-number">{{ calendarDay.day }}</div>
          
          <!-- 當天的控制項目 -->
          <div class="day-items">
            <div 
              class="calendar-item" 
              *ngFor="let item of calendarDay.items"
              [class.priority-high]="item.priority === 'high'"
              [class.priority-medium]="item.priority === 'medium'"
              [class.priority-low]="item.priority === 'low'"
              [class.status-pending]="item.status === 'pending'"
              [class.status-inProgress]="item.status === 'inProgress'"
              [class.status-completed]="item.status === 'completed'"
              (click)="onCalendarItemClick(item)"
              [title]="item.title + '\n' + item.description">
              
              <div class="item-indicator">
                <span class="item-title-short">{{ item.title | slice:0:8 }}{{ item.title.length > 8 ? '...' : '' }}</span>
                <span class="item-status-dot" [ngClass]="getStatusClass(item.status)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- 彈出式編輯項目視窗 -->
  <div class="modal-overlay" *ngIf="showEditForm && editingItem">
    <div class="modal-container">
      <div class="modal-header">
        <h2>{{ 'control_list.form.edit_title' | translate }}</h2>
        <button class="close-button" (click)="cancelEdit()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="edit-title">{{ 'control_list.form.title_label' | translate }} <span class="required">{{ 'control_list.form.required' | translate }}</span></label>
          <input type="text" id="edit-title" [(ngModel)]="editingItem.title">
        </div>

        <!-- 所屬部門選擇 -->
        <div class="form-group">
          <label for="edit-department">{{ 'control_list.form.department_label' | translate }}</label>
          <select
            id="edit-department"
            [(ngModel)]="editingItem.departmentId"
            [disabled]="!departmentsLoaded">
            <option value="">{{ departmentsLoaded ? ('control_list.form.department_placeholder' | translate) : ('control_list.form.loading' | translate) }}</option>
            <option *ngFor="let dept of departments" [value]="dept.id">
              {{ formatDepartmentName(dept) }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="edit-description">{{ 'control_list.form.description_label' | translate }}</label>
          <textarea id="edit-description" [(ngModel)]="editingItem.description" rows="3"></textarea>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label for="edit-dueDate">{{ 'control_list.form.due_date_label' | translate }} <span class="required">{{ 'control_list.form.required' | translate }}</span></label>
            <input type="date" id="edit-dueDate" [(ngModel)]="editingItem.dueDate">
          </div>

          <div class="form-group half-width">
            <label for="edit-assignedTo">{{ 'control_list.form.assigned_to_label' | translate }}</label>
            <select id="edit-assignedTo" [(ngModel)]="editingItem.assignedTo" [disabled]="isLoadingUsers">
              <option value="">{{ 'control_list.form.assigned_to_placeholder' | translate }}</option>
              <option *ngFor="let user of userList" [value]="user.name">
                {{ user.name }} ({{ user.account }})
              </option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="edit-priority">{{ 'control_list.form.priority_label' | translate }}</label>
          <select id="edit-priority" [(ngModel)]="editingItem.priority">
            <option value="low">{{ 'control_list.form.priority.low' | translate }}</option>
            <option value="medium">{{ 'control_list.form.priority.medium' | translate }}</option>
            <option value="high">{{ 'control_list.form.priority.high' | translate }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="edit-status">{{ 'control_list.form.status_label' | translate }}</label>
          <select id="edit-status" [(ngModel)]="editingItem.status">
            <option value="pending">{{ 'control_list.status.pending' | translate }}</option>
            <option value="inProgress">{{ 'control_list.status.in_progress' | translate }}</option>
            <option value="completed">{{ 'control_list.status.completed' | translate }}</option>
          </select>
        </div>

        <!-- 檔案上傳區域（當狀態為已完成時顯示） -->
        <div class="form-group" *ngIf="editingItem.status === 'completed'">
          <label>{{ 'control_list.form.file_upload_label' | translate }}</label>
          
          <!-- 上傳進度 -->
          <div class="upload-progress" *ngIf="uploadProgress > 0 && uploadProgress < 100">
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="uploadProgress"></div>
            </div>
            <span class="progress-text">{{ uploadProgress }}%</span>
          </div>
          
          <!-- 已上傳的檔案清單 -->
          <div class="uploaded-files" *ngIf="editingItem.attachments && editingItem.attachments.length > 0">
            <div class="file-item" *ngFor="let attachment of editingItem.attachments">
              <i class="fas fa-file"></i>
              <span class="file-name">{{ attachment.name }}</span>
              <span class="file-size">({{ formatFileSize(attachment.size) }})</span>
              <button type="button" class="remove-file-btn" (click)="removeAttachment(attachment.id)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- 檔案選擇區域 -->
          <div class="file-upload-area">
            <input type="file" id="edit-files" multiple (change)="onFileSelected($event)" #fileInput>
            <label for="edit-files" class="file-upload-label">
              <i class="fas fa-cloud-upload-alt"></i>
              <span>{{ 'control_list.form.file_select' | translate }}</span>
              <span class="file-hint">{{ 'control_list.form.file_upload_hint' | translate }}</span>
            </label>
          </div>

          <!-- 已選擇但尚未上傳的檔案 -->
          <div class="selected-files" *ngIf="selectedFiles.length > 0">
            <p class="selected-files-title">{{ 'control_list.form.selected_files' | translate }}</p>
            <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
              <i class="fas fa-file"></i>
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">({{ formatFileSize(file.size) }})</span>
              <button type="button" class="remove-file-btn" (click)="removeSelectedFile(i)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" (click)="cancelEdit()">{{ 'control_list.form.cancel' | translate }}</button>
        <button class="submit-button" (click)="saveEdit()">{{ 'control_list.form.save' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- 彈出式新增項目視窗 -->
  <div class="modal-overlay" *ngIf="showAddForm">
    <div class="modal-container">
      <div class="modal-header">
        <h2>{{ 'control_list.form.add_title' | translate }}</h2>
        <button class="close-button" (click)="cancelAdd()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="title">{{ 'control_list.form.title_label' | translate }} <span class="required">{{ 'control_list.form.required' | translate }}</span></label>
          <input type="text" id="title" [(ngModel)]="newItem.title" [placeholder]="'control_list.form.title_placeholder' | translate">
        </div>

        <!-- 所屬部門選擇 -->
        <div class="form-group">
          <label for="department">{{ 'control_list.form.department_label' | translate }}</label>
          <select
            id="department"
            [(ngModel)]="newItem.departmentId"
            [disabled]="!departmentsLoaded">
            <option value="">{{ departmentsLoaded ? ('control_list.form.department_placeholder' | translate) : ('control_list.form.loading' | translate) }}</option>
            <option *ngFor="let dept of departments" [value]="dept.id">
              {{ formatDepartmentName(dept) }}
            </option>
          </select>
        </div>

        <!-- 擔當者 -->
        <div class="form-group">
          <label for="assignedTo">{{ 'control_list.form.assigned_to_label' | translate }}</label>
          <select id="assignedTo" [(ngModel)]="newItem.assignedTo" [disabled]="isLoadingUsers">
            <option value="">{{ 'control_list.form.assigned_to_placeholder' | translate }}</option>
            <option *ngFor="let user of userList" [value]="user.name">
              {{ user.name }} ({{ user.account }})
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="description">{{ 'control_list.form.description_label' | translate }}</label>
          <textarea id="description" [(ngModel)]="newItem.description" rows="3" [placeholder]="'control_list.form.description_placeholder' | translate"></textarea>
        </div>

        <!-- 期限日 -->
        <div class="form-group">
          <label for="dueDate">{{ 'control_list.form.due_date_label' | translate }} <span class="required">{{ 'control_list.form.required' | translate }}</span></label>
          <input type="date" id="dueDate" [(ngModel)]="newItem.dueDate">
        </div>

        <!-- 優先度 -->
        <div class="form-group">
          <label for="priority">{{ 'control_list.form.priority_label' | translate }}</label>
          <select id="priority" [(ngModel)]="newItem.priority">
            <option value="low">{{ 'control_list.form.priority.low' | translate }}</option>
            <option value="medium">{{ 'control_list.form.priority.medium' | translate }}</option>
            <option value="high">{{ 'control_list.form.priority.high' | translate }}</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" (click)="cancelAdd()">{{ 'control_list.form.cancel' | translate }}</button>
        <button class="submit-button" (click)="submitNewItem()">{{ 'control_list.form.add' | translate }}</button>
      </div>
    </div>
  </div>
</div>
